export default __webpack_public_path__ + "static/media/refresh.6aa9d08a.svg";